<template>
  <div class="input-field--container">
    <div v-html="title" class="input-field__title" />
    <input
      class="input-field--input"
      type="number"
      :value="value"
      @input="onInput"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{ disabled: disabled }"
      min="0.0"
      max="999.0"
      :name="name"
    />
    <div class="input-filed__unit">{{ unit }}</div>
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    value: {
      required: true,
      // propsの受け取りデータ型をstringとnull(初期値)に限定する
      validator: prop => typeof prop === "number" || prop === null
    },
    placeholder: VueTypes.string,
    unit: VueTypes.string,
    title: VueTypes.string,
    //初期値をfalseにしないと全部入力不可になる
    disabled: VueTypes.bool.def(false),
    name: VueTypes.string
  },
  methods: {
    onInput: function(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style scoped>
.input-field--container {
  display: grid;
  grid-template-columns: 2fr 5fr 0.5fr;
  gap: 20px;
  margin-top: 20px;
  align-items: center;
}
@media screen and (max-width: 599px) {
  .input-field--container {
    grid-template-columns: 1fr 1fr;
  }
  .input-filed__unit {
    display: none;
  }
}
.input-field__title {
  text-align: left;
  padding-left: 10px;
}
.input-field--input {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 40px;
  font-size: calc(100% + 0.25vw);
}
.disabled {
  background: #dcdcdc;
  cursor: not-allowed;
}
</style>
